/* eslint-disable max-lines-per-function */
/* eslint-disable @typescript-eslint/no-explicit-any */

import React, { JSX, useState } from 'react';

import { Modal } from 'react-bootstrap';

import Styles from './ServiceOptionCard.module.scss';
import ServiceDetailsSection from './ServiceDetailSection';
import ServiceOptionPrice from '../ServiceOptionPrice/ServiceOptionPrice';
import * as ComponentLibrary from '../../../index';
import RichText from '../../../richtext';
import { getStaticAssetPath } from '../../../../utils/global';
import { RecommendedOptionsTranslations } from '../../types';
import { getTranslation } from '../../RecommendedOptionsUtils';
import { GAEVENT, CTABUTTONCLICK } from '../../../../Analytics/AnalyticsConstants';
const TV_TAB_KEY = 'TV';

const StoryblokComponent: React.FC<{ content: any }> = ({ content }) => {
  if (!content || typeof content !== 'object') {
    return null;
  }

  const componentName = (content as Record<string, any>)?.component;
  if (!componentName || typeof componentName !== 'string') {
    return null;
  }

  const ComponentImpl = (ComponentLibrary as Record<string, React.ComponentType<any>>)[
    componentName
  ];

  if (!ComponentImpl) {
    console.warn('ServiceOptionCard: Missing component renderer', componentName);
    return null;
  }

  return <ComponentImpl {...content} />;
};
interface CountryState {
  sbStaticConstants?: Record<string, string>;
}

interface CartState {
  chanelLists?: Record<string, string[]>;
}

const selectCartState = (state: any): CartState => {
  if (state?.cart) {
    return state.cart as CartState;
  }

  return (state ?? {}) as CartState;
};

type ServiceOptionCardInterface = {
  content: any;
  checked: boolean;
  onClick: (id: string, check: boolean, quantity: number) => void;
  offer: any;
  category: string;
  show: boolean;
  setShowpop: any;
  serviceOptions: any[];
  activeTab: string;
  translations: RecommendedOptionsTranslations;
  cartLoading: boolean;
  beneficiaryProducts: any[];
};

const ServiceOptionCard = ({
  content,
  checked = false,
  onClick,
  offer,
  category,
  show = false,
  setShowpop,
  serviceOptions,
  activeTab,
  translations,
  cartLoading = false,
  beneficiaryProducts
}: ServiceOptionCardInterface): JSX.Element => {
  const [isDetailsOverlay, setIsDetailsOverlay] = useState<boolean>(false);
  const chanelLists: any = {};
  const [cardOverlayDetails, setCardOverlayDetails] = useState<any>([]);

  const handleClick = (count?: number) => {
    const tvQuantity = count === undefined ? 1 : count || 0;
    const newchecked = content?.code === 'HZN TV MultiBox' ? tvQuantity : !checked;
    onClick(content.code, Boolean(newchecked), Number(newchecked));
  };

  const handleBackClick = () => {
    // Track back button click with analytics
    try {
      if (typeof window !== 'undefined' && window.dataLayer) {
        const clickText = getTranslation(translations, 'back') ?? 'Back';
        const headline =
          cardOverlayDetails?.[0]?.displayName ||
          cardOverlayDetails?.[0]?.title ||
          cardOverlayDetails?.[0]?.code ||
          '';

        window.dataLayer.push({
          event: GAEVENT,
          event_name: CTABUTTONCLICK,
          link_url: '',
          click_text: clickText,
          headline: headline
        });
      }
    } catch (error) {
      console.error('Analytics tracking error (cta_button_click):', error);
    }

    setIsDetailsOverlay(!isDetailsOverlay);
    setShowpop(true);
  };

  const cardClassNames = [Styles.card, 'card'];

  if (checked) {
    cardClassNames.push(Styles.cardActive);
  }

  return (
    <div className={cardClassNames.join(' ')}>
      {content?.badge && (
        <div className={Styles.badge}>
          <img
            src={getStaticAssetPath('/icons/discount_circle_white.svg')}
            className='me-1'
            width={24}
            height={24}
            alt='discount circle'
          />
          {content?.badge}
        </div>
      )}
      <div className='d-flex justify-content-between'>
        <div className={`fw-bold mb-2 fs-18 ${Styles.heading}`}>{content?.displayName}</div>

        {activeTab === TV_TAB_KEY && category !== 'all' && (
          <img
            src={
              content?.icon?.filename
                ? content?.icon?.filename
                : getStaticAssetPath(`/icons/${category}.svg`)
            }
            className='rounded-circle'
            width={40}
            height={40}
            alt='TV'
          />
        )}
      </div>

      <ServiceDetailsSection
        text={content?.description?.content?.[0].content?.[0]?.text}
        description={content?.description}
        setIsDetailsOverlay={setIsDetailsOverlay}
        isDetailsOverlay={isDetailsOverlay}
        setCardOverlayDetails={setCardOverlayDetails}
        content={content}
        setShowpop={setShowpop}
        serviceOptions={serviceOptions}
        handleClick={handleClick}
        detailsBtn={content?.disableDetailsBtn}
        checked={checked}
        translations={translations}
        cartLoading={cartLoading}
      />

      {isDetailsOverlay && (
        <div>
          <Modal
            contentClassName={Styles.errormodal}
            show={show}
            dialogClassName={Styles.errordialogbox}
            centered
          >
            <Modal.Header className={Styles.header} />
            <div className={Styles.errorwrapper}>
              <Modal.Body className={Styles.body}>
                <>
                  <div className={Styles.backDetail}>
                    <div className={`${Styles.backIcons}`} onClick={handleBackClick}></div>
                    <button className={`${Styles.backButton}`} onClick={handleBackClick}>
                      {getTranslation(translations, 'back')}
                    </button>
                  </div>
                  {cardOverlayDetails?.map((data: any) => {
                    return (
                      <>
                        <div className={`${Styles.detailHeader}`}>
                          {data?.displayName ? (
                            <div className={Styles.displayName}>{data?.displayName}</div>
                          ) : (
                            ''
                          )}
                          <div>
                            <ServiceOptionPrice
                              content={offer}
                              isDetailsOverlay={isDetailsOverlay}
                              translations={translations}
                              beneficiaryProducts={beneficiaryProducts}
                            />
                          </div>
                        </div>
                        {data?.description || data?.optionsDetails || data?.productDetailsPDF ? (
                          <div className={`${Styles.mainContent}`}>
                            {data?.description ? (
                              <div className={Styles.container}>
                                <div
                                  className={`${Styles.details} ${
                                    !chanelLists?.[data?.upcPackageDCH]
                                      ? Styles.fullwidthchannels
                                      : ''
                                  }`}
                                >
                                  <div className={Styles.optionsTitle}>
                                    {getTranslation(translations, 'details')}
                                  </div>
                                  <div className={Styles.mockeddescription}>
                                    <RichText content={data?.description} />
                                  </div>

                                  {chanelLists?.[data?.upcPackageDCH] && (
                                    <hr className='mt-4 mb-0 d-sm-none' />
                                  )}
                                </div>

                                {chanelLists?.[data?.upcPackageDCH] && (
                                  <div className='vr d-none d-sm-block mx-3'></div>
                                )}
                                {/* Bootstrap Vertical Divider */}

                                {chanelLists?.[data?.upcPackageDCH] && (
                                  <div className={`${Styles.channels}`}>
                                    <div className={Styles.optionsTitle}>
                                      {getTranslation(translations, 'channels')}
                                    </div>
                                    <div className={Styles.mockdescription}>
                                      {chanelLists?.[data?.upcPackageDCH].join(', ')}
                                    </div>
                                  </div>
                                )}
                              </div>
                            ) : (
                              ''
                            )}
                            {data?.optionsDetails?.map((descriptiondata: any) => (
                              <>
                                <div
                                  className={`${Styles.mockdescription} ${Styles.optionDetailscolor}`}
                                >
                                  <StoryblokComponent content={descriptiondata} />
                                </div>
                                <hr className='my-3' />
                              </>
                            ))}
                            {data?.productDetailsPDF ? (
                              <div>
                                <div className={Styles.optionTitle}>
                                  {getTranslation(translations, 'download_pdf')}
                                </div>
                                <div className='mb-3'>
                                  <RichText content={data?.productDetailsPDF} />
                                </div>
                              </div>
                            ) : (
                              ''
                            )}
                          </div>
                        ) : (
                          ''
                        )}
                      </>
                    );
                  })}
                </>
              </Modal.Body>
            </div>
          </Modal>
        </div>
      )}

      {/**Code for the FOoter segment of the Service Options where price and add|remove button would be there */}
      <div className='mt-auto'>
        <div className='d-flex align-items-center mt-3'>
          <ServiceOptionPrice
            content={offer}
            showOptionToolTip={content?.hideTooltip}
            translations={translations}
            beneficiaryProducts={beneficiaryProducts}
          />
          {!checked && (
            <div className='ms-auto'>
              <button
                onClick={() => {
                  if (!cartLoading) handleClick();
                }}
                disabled={cartLoading}
                className={`${Styles.secondaryButton}`}
              >
                {getTranslation(translations, 'add') ?? 'add'}
                <span className={`${Styles.cartIcon} ms-2`} aria-hidden='true' />
              </button>
            </div>
          )}

          {!!checked && (
            <div className='ms-auto'>
              <button
                onClick={() => {
                  if (!cartLoading) handleClick(0);
                }}
                disabled={cartLoading}
                className={`text-button py-3 ${Styles.textButton}`}
              >
                {getTranslation(translations, 'remove') ?? 'Remove'}
                <img
                  src={getStaticAssetPath('/icons/trash.svg')}
                  className='ms-2'
                  alt='trash icon'
                />
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ServiceOptionCard;
